import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch } from "vue";
import ModalSorteo from "../ModalSorteo.vue";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import ModalAddEquipo from "./ModalAddEquipo.vue";
import ModalParametrosPrimeraRondaEquipo from "./ModalParametrosPrimeraRondaEquipo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionAccionesTorneoEquipo',
  props: {
    torneo: {},
    rondaGenerada: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const isLoading = ref<boolean>(true);
const isGenerating = ref<boolean>(false);
const showConfigModal = ref<boolean>(false);
const showSorteoModal = ref<boolean>(false);
const showModalAddEquipo = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const nicks = ref<string[]>([]);

const openConfigModal = async () => {
  isGenerating.value = true;
  if (!props.torneo) return;

  showConfigModal.value = true;
};

const openSorteo = async () => {
  isLoading.value = true;

  if (props.torneo) {
    nicks.value = props.torneo.equipos.flatMap((equipo) =>
      equipo.inscripciones.map((i) => i.nick)
    );
  }

  showSorteoModal.value = true;
  isLoading.value = false;
};

const closeSorteoModal = () => {
  showSorteoModal.value = false;
};

const openAddEquipo = async () => {
  showModalAddEquipo.value = true;
};

const closeConfigModal = () => {
  showConfigModal.value = false;
  isGenerating.value = false;
};

const closeModalAddEquipo = () => {
  showModalAddEquipo.value = false;
};

const handleConfigConfirm = () => {
  closeConfigModal();
  window.location.reload();
};

const handleAddEquipoConfirm = () => {
  showModalAddEquipo.value = false;
  showSuccessModal.value = false;
  window.location.reload();
};

watch(
  () => showSuccessModal.value,
  (newValue) => {
    if (!newValue) {
      window.location.reload();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.torneo)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mb-4 pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold" }, {
            default: _withCtx(() => [
              _createTextVNode("Acciones")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { dense: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        variant: "tonal",
                        color: "secondary",
                        onClick: openAddEquipo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Añadir Equipo ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        variant: "tonal",
                        color: "primary",
                        onClick: openConfigModal,
                        disabled: _ctx.rondaGenerada || isGenerating.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Generar Ronda 1 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        variant: "tonal",
                        color: "primary",
                        onClick: openSorteo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Sorteo ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(ModalParametrosPrimeraRondaEquipo, {
            isVisible: showConfigModal.value,
            torneo: _ctx.torneo,
            onClose: closeConfigModal,
            onConfirm: handleConfigConfirm
          }, null, 8, ["isVisible", "torneo"]),
          _createVNode(ModalAddEquipo, {
            isVisible: showModalAddEquipo.value,
            torneo: _ctx.torneo,
            onClose: closeModalAddEquipo,
            onConfirm: handleAddEquipoConfirm
          }, null, 8, ["isVisible", "torneo"]),
          _createVNode(ModalSorteo, {
            isVisible: showSorteoModal.value,
            participantes: nicks.value,
            onClose: closeSorteoModal
          }, null, 8, ["isVisible", "participantes"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})